export const getMessages = state => {
  return state.messages
}
